import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  mainContainer: {
    padding: 12,
  },

  container: {
    flexDirection: "row",
    marginTop: "5%",
    width: "80%",
    marginLeft: "10%",
  },
  circulationContent: {
    flexDirection: "row",
    justifyContent: "space-between",
    flex: 1,
  },
  titleCirculation: {
    marginBottom: 6,
    alignItems: "left",
    fontSize: 16,
    fontWeight: "bold",
  },
  amountCirculation: {
    alignItems: "right",
    fontSize: 16,
    fontWeight: "400",
  },
  contentDescription: {
    fontSize: 16,
    textAlign: "justify",
    marginBottom: 20,
  },
  titleDescription: {
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 6,
  },
  descriptionContainer: {
    marginTop: 12,
    flexDirection: "column",
    justifyContent: "space-between",
    flex: 1,
  },
  containerFiles: {
    width: "100%",
    padding: 12,
    borderWidth: 1,
    borderColor: "#077A97",
    borderRadius: 8,
    flexDirection: "column",
    justifyContent: "space-between",
    marginTop: 40,
    marginBottom: 12,
    gap: 10,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },
  titleDescriptionFiles: {
    fontSize: 16,
    fontWeight: "bold",
  },
  contentFiles: {
    flexDirection: "row",
    fontSize: 16,
    fontWeight: "bold",
    marginLeft: 2,
    maxWidth: "100%",
  },

  imgDownload: {
    tintColor: "#077A97",
    width: 22,
    height: 22,
    marginRight: 6,
    marginTop: 6,
  },

  nomeArquivo: {
    flexWrap: "wrap",
    width: "100%",
    fontSize: 16,
    paddingTop: 10,
    maxWidth: "100%",
  },

  containerImgNameToken: {
    flexDirection: "column",
    alignItems: "flex-start",
  },

  imageBanners: {
    width: 310,
    marginTop: 110,
  },

  btnRastreabilidade: {
    fontSize: 18,
    textTransform: "uppercase",
    marginVertical: 6,
    padding: 10,
    width: "100%",
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    position: "relative",
  },

  contRastreioVoltar: {
    flexDirection: "column",
    maxWidth: 310,
    padding: 0,
  },
});

export default styles;
